//
import ProductModel from '@/models/Warehouse/WhProduct'

/**
 * 
 */
import ProductAppends from './appends'
import ProductIncludes from './includes'

/**
 *
 */
export default async id => {
    //
    try {
        //
        const response = await ProductModel.append( ProductAppends ).include( ProductIncludes ).find( id )
        //
        return response.repacking_children.map( e => ({ ...e, wh_product: response }) )
    } catch ( error ) {
        //
        return error.response.data
    }
}
